import Button from '@material-ui/core/Button';
import {Link, withRouter} from 'react-router-dom';
import React, {useEffect, useState} from 'react';
import {addFlashMessage} from '../../actions/flash-message';
import {connect} from 'react-redux';
import QuizUserResult from './QuizUserResult';
import {fetchUserQuiz} from '../../api';
import {buildAnswers} from '../../utils/common';
import {isEmpty} from 'lodash/lang';
import {Save, Share} from '@material-ui/icons';
import Grid from '@material-ui/core/Grid';
import PDFShareButtons from '../common/PDFShareButtons';
import {Typography} from '@material-ui/core';
import {PrimaryButton} from '../common/StyledButtons';

function QuizUserResultContainer(props) {
    const {match: {params: {quizUserId}}} = props;

    const [{quizDataDict, answers}, setData] = useState({});
    const [userName, setUserName] = useState('');
    const [userId, setUserId] = useState('');
    const [email, setEmail] = useState('');
    const [quizName, setQuizName] = useState('');
    const [returnTo, setReturnTo] = useState('');
    const [returnUrl, setReturnUrl] = useState('');
    const [numberOfAttempts, setNumberOfAttempts] = useState(1);

    useEffect(() => {
        fetchUserQuiz(quizUserId).then(data => {
            setData({quizDataDict: data, answers: buildAnswers(data.questions)});
        });
    }, []);

    useEffect(() => {
        if (!isEmpty(quizDataDict)) {
            setUserName(quizDataDict.shadowUser.userName);
            setUserId(quizDataDict.shadowUser.platformUserId);
            setEmail(quizDataDict.shadowUser.email);
            setQuizName(quizDataDict.name);
            setReturnTo(quizDataDict.returnTo);
            setReturnUrl(quizDataDict.returnUrl);
        }
    }, [quizDataDict]);

    if (isEmpty(quizDataDict)) {
        return null;
    }

    return (
        <div className="content-box">
            <div className="navigation-history-container">
                <Link to={`/quizzes`}>My Quizzes</Link> > <Link to={`/quizzes/${quizDataDict.quiz.$oid}/reports`}>
                Report: {quizName}</Link> > {unescape(userName)}
            </div>
            { quizDataDict.returnUrl ? <Typography variant="h6"><a href={quizDataDict.returnUrl}><PrimaryButton>Return to Course</PrimaryButton></a></Typography> : ""} 
            <QuizUserResult quizId={quizUserId}/>
        </div>
    );
}


const mapDispatchToProps = (dispatch) => ({
    addFlashMessage: (...args) => dispatch(addFlashMessage(...args)),
});

export default withRouter(connect(
    null,
    mapDispatchToProps
)(QuizUserResultContainer));
